import { render, staticRenderFns } from "./GRCFormSidebar.vue?vue&type=template&id=6ec9f11a&scoped=true&"
import script from "./GRCFormSidebar.vue?vue&type=script&lang=js&"
export * from "./GRCFormSidebar.vue?vue&type=script&lang=js&"
import style0 from "./GRCFormSidebar.vue?vue&type=style&index=0&id=6ec9f11a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec9f11a",
  null
  
)

export default component.exports